module.exports = __webpack_public_path__ + "img/syy.c1eb9bf9.png";